import { ApiUrls } from './ApiUrls'
import { ApiRequest, apiMethods } from './ApiUtils'

function login(body, onSuccess, onFail) {
  ApiRequest({
    url: ApiUrls.login,
    method: apiMethods.POST,
    data: body,
  })
    .then((response) => {
      onSuccess(response?.data)
    })
    .catch((err) => {
      console.log('callllll', err)
      onFail(err)
    })
}

function getOrderDetails(params, onSuccess, onFail) {
  const { id, token } = params
  const apiPath = `${ApiUrls.orderDetails}/${id}`
  ApiRequest({
    url: apiPath,
    method: apiMethods.GET,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      onSuccess(response?.data)
    })
    .catch((err) => {
      onFail(err)
    })
}

function payResponse(data, onSuccess, onFail) {
  const { orderCode, transactionCode } = data
  const apiPath = `${ApiUrls.payResponse}/${orderCode}/${transactionCode}`
  ApiRequest({
    url: apiPath,
    method: apiMethods.GET,
  })
    .then((response) => {
      onSuccess(response?.data)
    })
    .catch((err) => {
      onFail(err)
    })
}

export default {
  getOrderDetails,
  payResponse,
  login,
}
